import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../../../../axios.js";
import {
  DELETE_SUBSCRIBER,
  CREATE_SUBSCRIBER
} from "../../../../Urls.js";

const initialState = {
  deleteFiberService: { data: [], loading: false, successMessage: "" },
};

export const deleteSubscriber = createAsyncThunk(
  "app/delete/deleteSubscriber",
  async (
    { subscriberid, subscriberserviceid, serviceReferenceNumber, oltId, ontId },
    { rejectWithValue }
  ) => {
    try {
      const url = `${DELETE_SUBSCRIBER}`;

      // build params dynamically, only include non-empty values
      const params = {
        deleteSubscriber: true,
        ...(subscriberid && { subscriberid }),
        ...(subscriberserviceid && { subscriberserviceid }),
        ...(serviceReferenceNumber && { serviceReferenceNumber }),
        ...(oltId && { oltId }),
        ...(ontId && { ontId }),
      };

      const response = await axios.delete(url, { params });
      return response;
    } catch (error) {
      // return rejectWithValue(error.response?.data || "Delete failed");
    }
  }
);

export const createSubscriber = createAsyncThunk(
  "app/delete/createSubscriber",
  async (payload) => {
    try {
      const url = `${CREATE_SUBSCRIBER}`;
      const response = await axios.post(url, payload);
      return response;
    } catch (error) {
      // return rejectWithValue(error.response?.data || "Delete failed");
    }
  }
);



export const manageFiberServiceSlice = createSlice({
  name: "app/manageFiberServiceSlice",
  initialState,
  reducers: {
    selectedDocument: (state, action) => {
      state.selectedAnnucementItem = action?.payload;
    },
    clearSuccessMessage: (state) => {
      state.uploadDocument.successMessage = "";
      state.downloadDocumentData.successMessage = "";
      state.deleteFiberService.successMessage = "";
    },
  },

  extraReducers: (builder) => {
    builder
      
      .addCase(deleteSubscriber.pending, (state) => {
        state.deleteFiberService.loading = true;
      })
      .addCase(deleteSubscriber.fulfilled, (state, action) => {
        state.deleteFiberService.loading = false;
        state.deleteFiberService.data = action?.payload?.data?.data;
        state.deleteFiberService.successMessage =
          "Document deleted successfully!";
      })
      .addCase(deleteSubscriber.rejected, (state) => {
        state.deleteFiberService.loading = false;
        state.deleteFiberService.successMessage = "Failed to delete Document .";
      });
  },
});

export const { selectedDocument, clearSuccessMessage } = manageFiberServiceSlice.actions;

export default manageFiberServiceSlice.reducer;
